import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import Highlighter from 'react-highlight-words';

import BundleCover from './BundleCover';
import { Trans, useTranslation } from 'react-i18next';

type Props = {
    readonly bundle: {
        readonly id?: string;
        readonly bundleId?: string;
        readonly title?: string;
        readonly coverUrl?: string;
        readonly sidebarTopHit?: boolean;
    };
    readonly title?: string;
    readonly relatedType?: string;
    readonly keyWord?: string;
    readonly containsText?: boolean;
    readonly showArrow?: boolean;
};

const RelatedTile: FC<Props> = ({ bundle = {}, title = '', relatedType = '', keyWord, containsText, showArrow }) => {
    const { t } = useTranslation();

    return (
        <div className="prd-dtl-bndl">
            <Link to={`/bundles/${bundle.bundleId}`}>
                <div className="bndl-cover-related">
                    <BundleCover bundle={bundle} />
                </div>
                {bundle.sidebarTopHit ? (
                    <div className="txt-normal related-bundle-title">
                        <Highlighter
                            key={`related-bundle-tile-${bundle.id}`}
                            autoEscape={true}
                            highlightClassName="related-highlight"
                            searchWords={[keyWord!]}
                            textToHighlight={bundle.title!}
                        />
                    </div>
                ) : (
                    <div style={{ marginTop: '12px', lineHeight: '18px' }} className="txt-normal">
                        {bundle.title}
                    </div>
                )}
            </Link>
            <div style={{ lineHeight: '18px' }} className="txt-smaller">
                {containsText && keyWord ? (
                    <div>
                        <Trans
                            i18nKey="components.searchResults.containsText"
                            components={{ span: <span className="related-keyword" /> }}
                            values={{ keyword: keyWord }}
                        />
                    </div>
                ) : relatedType === 'authorRelated' ? (
                    t('components.searchResults.authorRelated', { title })
                ) : (
                    t('components.searchResults.contains', { title })
                )}
            </div>
            {showArrow && <i className="material-icons">arrow_forward</i>}
        </div>
    );
};

export default RelatedTile;
